import { FC, memo, useState } from 'react'

import { Button, Text } from '@cash-me/react-components'
import NextImage from 'next/image'

import { Col, Grid } from 'components/grid'
import useWindowSize from 'hooks/useWindowSize'
import { pushDataLayer } from 'utils/push-data-layer'

import { WHISTLEBLOWING_URL } from '../documents'

import { DESIGN_PANEL_CONTENT_WIDTH, flowSteps } from './data'
import * as S from './styles'

const dataLayer = {
  category: 'Clique',
  action: 'Programa de Integridade',
  label: 'Processo de denúncia - Acesse o Canal de Denúncias'
}

const WhistleblowingFlow: FC = memo(() => {
  const { isDesktop } = useWindowSize()
  const [activeStep, setActiveStep] = useState(0)

  const step = flowSteps[activeStep]

  const handleClick = () => {
    pushDataLayer(dataLayer)
    window.open(WHISTLEBLOWING_URL, '_blank', 'noopener,noreferrer')
  }

  return (
    <S.Section $bg="medium">
      <Grid col={{ phone: 1, tablet: 1 }}>
        <Col col={{ desktop: 10 }} start={{ desktop: 2 }}>
          <S.TitleWrapper>
            <Text as="h2" size="heading2" weight="medium" color="var(--colors-neutral-text-default)">
              Conheça como ocorre o processo de tratamento de uma denúncia na CashMe:
            </Text>
          </S.TitleWrapper>

          {/* Uma barra de etapas, não abas: aria-current="step" descreve o
              estado melhor que aria-selected e não exige o teclado de tablist. */}
          <S.Steps>
            {flowSteps.map(({ id, title }, index) => (
              <S.StepButton
                key={id}
                type="button"
                $active={index === activeStep}
                aria-current={index === activeStep ? 'step' : undefined}
                onClick={() => setActiveStep(index)}
              >
                {title}
              </S.StepButton>
            ))}
          </S.Steps>

          <S.Panel>
            <S.PanelBody aria-live="polite">
              <S.PanelText>
                <Text as="h3" size="heading3" weight="medium" color="var(--colors-neutral-text-contrast-default)">
                  {step.id}. {step.title}
                </Text>
                <Text size="heading4" color="var(--colors-neutral-text-contrast-default)">
                  {step.description}
                </Text>
              </S.PanelText>

              <S.Illustration aria-hidden $ratio={step.illustration.width / DESIGN_PANEL_CONTENT_WIDTH}>
                <NextImage
                  src={step.illustration.src}
                  alt=""
                  width={step.illustration.width}
                  height={step.illustration.height}
                />
              </S.Illustration>
            </S.PanelBody>

            <S.PanelFooter>
              <Button {...(isDesktop ? { size: 'lg' } : { size: 'md' })} onClick={handleClick}>
                Acesse o Canal de Denúncias
              </Button>

              <S.Dots>
                {flowSteps.map(({ id, title }, index) => (
                  <S.Dot
                    key={id}
                    type="button"
                    $active={index === activeStep}
                    aria-label={`Ir para a etapa ${id}: ${title}`}
                    onClick={() => setActiveStep(index)}
                  />
                ))}
              </S.Dots>
            </S.PanelFooter>
          </S.Panel>
        </Col>
      </Grid>
    </S.Section>
  )
})

WhistleblowingFlow.displayName = 'WhistleblowingFlow'

export default WhistleblowingFlow
